@if (currentRoute === 'saml-sso') {
<router-outlet></router-outlet>
} @else if (isAuthenticated | async) {
<div id="app-wrapper">
  @if (user$ | async; as loggedinuser) {
  <div
    class="compact-masthead"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
  >
    <ats-masthead
      currentModule="Admin"
      [person]="loggedinuser"
      [flagsmithEnvId]="mastheadFlagsmithEnvId"
      [buildNumber]="buildNumber"
    ></ats-masthead>
    <div fxFlex></div>
    <div><i class="efpicon efpicon-location"></i></div>
    <div>
      <app-efp-auth-tenant-switcher [useCompactMastheadTheme]="true"></app-efp-auth-tenant-switcher>
      <app-efp-auth-tenant-switcher-headless
        #tenantSwitcherHeadless
      ></app-efp-auth-tenant-switcher-headless>
    </div>
    <efp-masthead-uservoice [person]="loggedinuser"></efp-masthead-uservoice>
    <efp-masthead-user
      [person]="loggedinuser"
      [showThemeSwitch]="(featureToggles$ | async).light_dark_mode_switch"
      [showContrastSwitch]="false"
    ></efp-masthead-user>
  </div>
  <div class="build">{{ buildNumber }}</div>
  <div
    id="viewport"
    class="viewport"
  >
    <ngx-loading-bar
      [fixed]="false"
      height="3px"
      color="#139DEB"
      [includeSpinner]="false"
    ></ngx-loading-bar>
    <router-outlet></router-outlet>
  </div>
  }
</div>
}
<app-efp-auth-tenant-discovery></app-efp-auth-tenant-discovery>
